import gql from '@/services/gql';
import query from './query';

const updateQuery = gql(query);

const updateResource = (
  component: any,
  resourceName: string,
) => ({
  data: (component[`${resourceName}s`] || [])
    .map((resource: any) => ({
      ...resource,
      [`${resourceName}_id`]: resource[resourceName].id,
      // remove linked record
      [resourceName]: undefined,
    }),
  ),
  on_conflict: {
    constraint: `vendor_component_pkey`,
    update_columns: [
      `${resourceName}_id`,
      'properties',
    ],
  },
});

export default (
  componentId: string,
  {
    component = {} as any,
    deleteVendorIds = [] as any,
    prices = [],
    priceRemoveIds = [],
  },
) => (
  updateQuery({
    component: {
      ...component,
      id: componentId,
      vendors: updateResource(component, 'vendor'),
    },
    delete_vendor_ids: deleteVendorIds,

    // update price (view)
    prices,
    priceRemoveIds,
  })
  .then((response: any) => {
    const { affected_rows: componentResult } = response.insert_component;
    const { affected_rows: vendor } = response.delete_vendor_component;

    if (!componentResult && !vendor) {
      throw {
        code: `COMPONENT_NOT_UPDATED`,
      };
    }
    return response;
  })
);
